import { getListByPlanPermission } from "../../../store/frontend/tags/actions";

const resource = '/v1/tags';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  getList() {
    return $axios.get(`${resource}/list`);
  },

  getLsTags() {
    return $axios.get(`${resource}-for-ls`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  getListById(payload){
    return $axios.post(`${resource}/list-by-ids`, payload);
  }
});
